import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Box } from "@mui/material";
import { useContext } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import MobileTopBar from "./MobileTopBar";

export default function Layout({ children }) {
  const { collapsed } = useContext(LayoutContext);
  const isMobile = useMediaQuery("(max-width:500px)");
  const theme = useTheme();
  const sidebarWidth = collapsed ? 80 : 280;

  return (
    <>
      <MobileTopBar />

      <Box sx={{ display: "flex", width: "100%", height: "100vh", overflow: "hidden" }}>
        <Sidebar />

        <Box
          sx={{
            flexGrow: 1,
            ml: isMobile ? 0 : `${sidebarWidth}px`,
            transition: "0.3s",
            height: "calc(100vh - 10px)",
            display: "flex",
            mt: '10px',
            flexDirection: "column",
            overflowX: "auto",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "10px",
              height: "10px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#ffffff",
            },
            "&::-webkit-scrollbar-thumb": {
              background: theme.palette.primary.main,
              borderRadius: "5px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: theme.palette.primary.dark,
            },
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
}
